<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item>
      <el-checkbox
        v-model="filters.onlyMy"
        key="checkbox"
        border
        @change="checkChange"
        >待我审核
      </el-checkbox>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.auditBizType"
        placeholder="审核类型"
      >
        <el-option
          v-for="(item, i) in auditBizTypeAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="审核状态"
      >
        <el-option
          v-for="(item, i) in auditStatusAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="视频名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";

export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      auditBizTypeAttr: [],
      auditStatusAttr: [],
    };
  },
  created() {
    this.getSysParamByTypes(["AUDIT_BIZ_TYPE", "AUDIT_STATUS"]);
  },
  methods: {
    checkChange(val) {
      this.filters.onlyMy = val;
      this.initData();
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["AUDIT_BIZ_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["AUDIT_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.auditBizTypeAttr = res.data["AUDIT_BIZ_TYPE"].slice(0, 3);
        this.auditStatusAttr = res.data["AUDIT_STATUS"].slice(0, 4);
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {
        onlyMy: false,
      };
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
